import { AlertReason } from "../models/entities/alert.model";
import { UseMyAlertsResult, useMyAlerts } from "./useMyAlerts";

/**
 * The logged-in user's unresolved sustained-out-of-range alerts, for the Home
 * worklist (KAN-2641).
 *
 * Reads the SAME `/api/tasks/` rows as Requires attention and critical alerts,
 * so a resolve from any surface refreshes this hook's shared query keys; it is
 * assignee == me unconditionally.
 *
 * Kept as its own module so tests can mock it independently.
 */
export const useMySoorAlerts = (assigneeId: number | undefined | null): UseMyAlertsResult =>
	useMyAlerts(assigneeId, AlertReason.SUSTAINED_OUT_OF_RANGE_READING);
